import { AboutSchool } from "./AboutSchool";

export default AboutSchool;
